import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Device, DeviceSyncStatus } from '../model/device';
import { HttpHelperService } from './httphelper.service';
import { DeviceIdentifier } from '../model/deviceIdentifier';
import { Observable } from 'rxjs';

const API_URL = environment.apiUrl;

@Injectable()
export class DeviceService {
	constructor(private http: HttpClient, private httpHelperService: HttpHelperService) {
	}

	getAvailableDevices(residentId: number) {
		return this.http.get<Device[]>(`${API_URL}device/GetAvailable?residentId=${residentId}&active=true&unassigned=true`, this.httpHelperService.getHttpOptions());
	}

	getResidentDevices(residentId: string) {
		return this.http.get<Device[]>(`${API_URL}device?residentId=${residentId}&active=true`, this.httpHelperService.getHttpOptions());
	}

	get() {
		return this.http.get<Device[]>(`${API_URL}device?active=true`, this.httpHelperService.getHttpOptions());
	}

	getCareHomeDevices(careHomeId: string) {
		if (!careHomeId) {
			careHomeId = '';
		}

		return this.http.get<Device[]>(`${API_URL}device/GetCareHomeDevices?careHomeId=${careHomeId}`, this.httpHelperService.getHttpOptions());
	}

	getSensorsDetails(sensorIds: DeviceSyncStatus[]) {
		const param= sensorIds.map(id => `ids=${id}`).join('&');
		return this.http
		.get<DeviceSyncStatus[]>(`${API_URL}device/GetSensorsDetails?${param}`, this.httpHelperService.getHttpOptions());
	}

	create(device: Device) {
		return this.http.post<Device>(`${API_URL}device`, device, this.httpHelperService.getHttpOptions());
	}

	upsert(device: Device) {
		return this.http.post<Device>(`${API_URL}device/UpsertCareHomeDevice`, device, this.httpHelperService.getHttpOptions());
	}

	update(device: Device, id: string) {
		return this.http.post<Device>(`${API_URL}device/${id}`, device, this.httpHelperService.getHttpOptions());
	}

	getById(id: string) {
		return this.http.get<Device>(`${API_URL}device/${id}`, this.httpHelperService.getHttpOptions());
	}

	getCareHomeDeviceById(id: string) {
		return this.http.get<Device>(`${API_URL}device/GetCareHomeDevice?id=${id}`, this.httpHelperService.getHttpOptions());
	}

	getBycarehome(carehomeId: string) {
		return this.http.get<Device[]>(`${API_URL}device/${carehomeId}/all?active=true`, this.httpHelperService.getHttpOptions());
	}

	getByIdBycarehome(carehomeId: string, id: string) {
		return this.http.get<Device>(`${API_URL}device/${carehomeId}/${id}`, this.httpHelperService.getHttpOptions());
	}

	search(serialNumber: string): Observable<HttpResponse<DeviceIdentifier>> {
		return this.http.get<DeviceIdentifier>(`${API_URL}device/search?serialNumber=${serialNumber}`, this.httpHelperService.getHttpOptions());
	}
}
